import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../services/rest/rest.service';
import { ChatConfig } from './chat.domain';
@Injectable({
  providedIn: 'root'
})
export class ChatRestService {
  private readonly restService = inject(RestService);

  getChatConfig(): Observable<ChatConfig> {
    return this.restService.getResource('chat.config').get();
  }

  triggerSessionAlive(): Observable<void> {
    return this.restService.getResource('session.keepalive').get();
  }
}
